import { get }      from '@/services/api/methods';
import { post }     from '@/services/api/methods';

export default {

	getPublishedDealPacks: ({
		include,
		searchString,
		filters,
		page,
		per,
		sortBy,
		sortDir
	}) => {
		return get('/deal-packs', {
			options: {
				include,
				searchString,
				filters,
				page,
				per,
				sortBy,
				sortDir
			}
		});
	},

	getPublishedPublicDealPacks: ({
		include,
		searchString,
		filters,
		page,
		per,
		sortBy,
		sortDir
	}) => {
		return get('/browse/deal-packs', {
			options: {
				include,
				searchString,
				filters,
				page,
				per,
				sortBy,
				sortDir
			}
		});
	},

	getPublishedDealPackById: ({ dealPackId }) => {
		return get(`/deal-packs/${dealPackId}`);
	},

	buyDealPackById: ({ dealPackId }) => {
		return post(`/deal-packs/${dealPackId}/checkout`);
	},

	getDealPackById: ({ dealPackId }) => {
		return get(`/user/deal-packs/${dealPackId}`);
	},

	getCurrentUsersDealPacks: ({
		include,
		searchString,
		page,
		per
	}) => {
		return get('/user/deal-packs', {
			options: {
				include,
				searchString,
				page,
				per
			}
		});
	},

	getEnrolmentById: ({ enrolmentId }) => {
		return get(`/user/enrolments/${enrolmentId}`);
	}
};
